const MobileDetect = require('mobile-detect');
// prettier-ignore
const KINDLE_DEVICES = /KFSUWI|KFAUWI|KFDOWI|KFGIWI|KFFOWI|KFMEWI|KFTBWI|KFARWI|KFASWI|KFSAWA|KFSAWI|KFAPWA|KFAPWI|KFAPWA|KFAPWI|KFSOWI|KFJWA|KFJWI|KFTT|KFOT|Kindle|Kindle Fire/i;

export default (platforms) => {
  const device = { type: 'unknown', os: 'unknown', family: 'unknown', version: 'unknown', isIE: false };

  const ua = window.navigator.userAgent;
  const md = new MobileDetect(ua);
  const isMobile = md.mobile() !== null;
  const isPhone = isMobile && md.phone() !== null;
  const isTablet = isMobile && md.tablet() !== null;
  const isDesktop = !isMobile && !isTablet;

  device.type = isDesktop ? 'desktop' : isPhone ? 'smartphone' : 'tablet';
  if (isDesktop) {
    device.isIE = ua.match(/windows/i) && (ua.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1);
  }

  const mobileDetectOS = md.os();

  // device.os = getOSforAppPage(mobileDetectOS);
  // device.family = mobileDetectOS === 'AndroidOS' ? 'android' : device.os === 'ios' ? 'ios' : 'unknown';

  console.log(`||||| platformMobileDetect detected ${mobileDetectOS} |||||`);
  let userPlatform = 'other';
  if (mobileDetectOS === 'iOS' || mobileDetectOS === 'iPadOS') {
    userPlatform = platforms.ios;
    device.os = 'ios';
    device.family = 'ios';
  } else if (ua.match(KINDLE_DEVICES)) {
    userPlatform = platforms.amazon;
    device.type = 'tablet';
    device.os = 'fire';
    device.family = 'android';
  } else if (mobileDetectOS === 'AndroidOS') {
    device.os = 'android';
    device.family = 'android';
    userPlatform = platforms.android;
  } else if (mobileDetectOS === 'WindowsMobileOS' || mobileDetectOS === 'WindowsPhoneOS') {
    device.os = 'windows';
    device.family = 'windows';
    userPlatform = platforms.windowsPhone;
  } else if (mobileDetectOS === 'BlackBerryOS') {
    device.os = 'blackberry';
    device.family = 'blackberry';
    userPlatform = platforms.blackberry;
  }

  console.log(`||||| platformMobileDetect device`, device, 'userPlatform', userPlatform);
  return { ...device, userPlatform };
};
